import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SIGUIENTE = { undefined: "pendiente", pendiente: "corregido", corregido: null };
const ESTILO = {
  pendiente: { clase: "bg-orange-500 border-orange-500", titulo: "Corrección pedida (clic: marcar como corregido)" },
  corregido: { clase: "bg-green-500 border-green-500", titulo: "Corregido (clic: quitar la marca)" },
  sinmarca: { clase: "bg-transparent border-slate-300 hover:border-slate-500", titulo: "Sin marca (clic: marcar corrección pedida)" },
};

export default function PuntoCorreccion({ dossierId, estado, onChange }) {
  const [guardando, setGuardando] = useState(false);
  const e = ESTILO[estado] || ESTILO.sinmarca;

  const cambiar = async (ev) => {
    ev.stopPropagation();
    if (guardando) return;
    const nuevo = SIGUIENTE[estado || "undefined"];
    setGuardando(true);
    try {
      await axios.put(`${API}/correcciones-res022/${dossierId}`, { estado: nuevo });
      onChange(nuevo);
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo cambiar la marca");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <button
      type="button"
      onClick={cambiar}
      title={e.titulo}
      data-testid={`punto-correccion-${dossierId}`}
      className={`ml-2 inline-block align-middle w-3 h-3 rounded-full border-2 ${e.clase} ${guardando ? "opacity-50" : ""}`}
    />
  );
}
